import $ from 'jquery';
import {subscribeVacancy} from '../api/api';
import isViewport from '../../scripts/util/window/isViewport';
import {sm} from '../../scripts/util/window/isViewport';

export default class Job {
	constructor() {
		this.selectors = {
			page: '.js-job-page',
			form: {
				wrapper: '.js-form',
				submit: '.js-form-submit',
				el: '.js-form-main',
				status: '.js-form-status'
			},
			slideToggle: {
				el: '.js-slide-el',
				wrapper: '.js-slide-wrapper'
			},
			wrapper: '.js-main-wrapper'
		};

		this.classes = {
			form: {
				status: 'form_state_status',
				error: 'form_state_error'
			},
			slideToggle: {
				hidden: 'slide-toggle_state_hidden'
			}
		};

		this.$page = $(this.selectors.page);
		this.$form = this.$page.find(this.selectors.form.el);
		this.$submit = this.$page.find(this.selectors.form.submit);
	}

	onSubmit = e => {
		e.preventDefault();
		const $target = $(e.target);
		const $wrapper = $target.closest(this.selectors.form.wrapper);
		const $data = $target.serialize();
		subscribeVacancy($data).then(
			data => this.setStatus($wrapper, data.message),
			data => this.setStatus($wrapper, data.message, true)
		);
	}

	onClick = e => {
		const $target = $(e.target);
		const $slideWrapper = $target.closest(this.selectors.slideToggle.wrapper);
		if (!isViewport(sm)) {
			$slideWrapper.css('height', 'auto');
		}
	}

	setStatus(el, status, isError = false) {
		const $slideToggle = el.closest(this.selectors.slideToggle.el);
		const $mainWrapper = el.closest(this.selectors.wrapper);
		const $status = el.find(this.selectors.form.status);
		$slideToggle.addClass(this.classes.slideToggle.hidden);
		$mainWrapper.css('height', '');
		el.removeClass(this.classes.form.error);
		el.addClass(this.classes.form.status);
		if (isError) {
			el.addClass(this.classes.form.error);
		}

		$status.text(status);
	}

	render() {
		if (this.$page.length) {
			this.$form.on('submit', this.onSubmit);
			this.$submit.on('click', this.onClick);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/job/index.js
 **/